import { render, staticRenderFns } from "./RecordForm.vue?vue&type=template&id=47ad2eaa&"
import script from "./RecordForm.vue?vue&type=script&lang=js&"
export * from "./RecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports